import { Card } from "primereact/card";

export const DashboardTopCompenet=({box, title, num, logo}:{box:string,title:string,num:string,logo:string})=>{

    return <div className="col-12 md:col-6 xl:col-3">
        <Card className={`grid-nogutter widget-overview-box widget-overview-box-${box}`}>
            <div className="flex justify-content-evenly">
                <span className="overview-icon">
                    <i className={logo}></i>
                </span>
                <span className="overview-title">{title}</span>
                <span className="overview-number">{num}</span>
            </div>
        </Card>
    </div>

};

export default DashboardTopCompenet;